export default __webpack_public_path__ + "static/media/1559.8912db6d.png";